// GeneralSettings.jsx

import React from 'react';

const GeneralSettings = () => {
  return (
    <div>
      {/* Inhoud voor algemene instellingen */}
      <h2>Algemene instellingen</h2>
    </div>
  );
};

export default GeneralSettings;